export enum SelectAllState {
  Deselected = 'deselected',
  Selected = 'selected',
  Selecting = 'selecting',
}
